export enum RecorderActionTypes {
  SET_RECORDER_OPEN = '@@recorder/SET_RECORDER_OPEN',
  SET_RECORDING = '@@recorder/SET_RECORDING',
  SET_STOP_RECORDING = '@@recorder/SET_STOP_RECORDING',
}
